module.exports = __webpack_public_path__ + "static/media/promo.e9efd812.png";